/*
    OneQuickShop 2.0.0 Usage (Webpack)
    yang @onerockwell        
*/

// Import all dependencies here
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import morphdom from 'morphdom';

import OneDrawer from '@/modules/module-oneDrawer';
import ViewProduct from '@/views/view-product';
import { PUB_SUB_EVENTS, subscribe, publish } from '@/lib/pubsub';


import '../../styles/pages/product.scss';
import '../../styles/pages/product/product-quickshop.scss';

// Define the Backbone View here (Optional)
let OneQuickShopView = Backbone.View.extend({
	
    initialize: function (settings) {
        console.log('init quickshop');
        var self = this;
        self.quickshop();
        // Close Quick Shop drawer when product is added to cart (e.g. from YMAL on cart page)
        self.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
            if (self.$currentModal && self.$currentModal.drawerOpened) {
                self.$currentModal.closeDrawer();
            }
        });
    },

    events: {
        
    },
    
    quickshop: function(){
        var self = this;
        
        /*
            Possible trigger of this function are :
            1. Click on '.quick-shop-trigger' which has data-url or href attribute.
            2. Click on '.swatch-linked' in quickshop container, which has data-url or href attribute.
            3. Direct call with 'event' object and target url as param.
        */
        var quickshopCtl = function(e,url){
            e.stopPropagation();
            e.preventDefault();
            
            var $curr = $(e.currentTarget);
            
            // Check if this is a single-variant product - if so, add to cart directly
            if ($curr.data('has-single-variant') === true || $curr.data('has-single-variant') === 'true') {
                const variantId = $curr.data('variant-id');
                const isAvailable = $curr.data('available') === true || $curr.data('available') === 'true';
                
                if (isAvailable && variantId) {
                    console.log('Single variant product - adding directly to cart');
                    
                    const formData = {
                        items: [{
                            id: parseInt(variantId),
                            quantity: 1
                        }]
                    };
                    
                    fetch('/cart/add.js', {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    })
                    .then(response => response.json())
                    .then(response => {
                        if (response.status) {
                            console.error('Error adding to cart:', response);
                        } else {
                            publish(PUB_SUB_EVENTS.cartUpdate, {...response, cartEvent: 'pdpAdd'});
                        }
                    })
                    .catch(error => {
                        console.error('Error adding to cart:', error);
                    });
                }
                return false;
            }
            
            if (url) {
                var url = ORW.utilities.updateUrlParam(url, 'view', 'quickshop');
            } else {
                var url = $curr.data('url') ? ORW.utilities.updateUrlParam($curr.data('url'), 'view', 'quickshop') : ORW.utilities.updateUrlParam($curr.attr('href'), 'view', 'quickshop');
            }

            console.log(url);
            
            if (url == '#?view=quickshop') {
                // Skip the empty URL 
                return false;
            }
            
            if (self.$currentQuickshop) {
                self.$currentQuickshop.destroy();
            }
            
            $.ajax({
                async: true,
                type: 'GET',
                url: url,
                cache: true,
                error: function(err) { 
                    console.log(err);
                },
                success: function(html) {
                    var $productDetail = $(html).find('.product-quickshop');
                    var quickshopHtml = $productDetail[0].outerHTML;
                    $productDetail.remove();
                    
                    if (self.$currentModal) {
                        // Clean up previous quickshop instance
                        if (self.$currentQuickshop && self.$currentQuickshop.destroy) {
                            self.$currentQuickshop.destroy();
                        }
                        
                        // Replace content html
                        self.$currentModal.$drawer.find('.product-quickshop').remove();
                        self.$currentModal.$drawer.find('.drawer-content').append(quickshopHtml);
                        self.$currentQuickshop = new ViewProduct({el: $('.product-quickshop .product-detail-container')});
                        
                        // Re-initialize marketing watchers for the new quickshop content
                        if (ORW.marketing && ORW.marketing.initQuickshopWatchers) {
                            ORW.marketing.initQuickshopWatchers();
                        } 
                    } else {
                        OneDrawer.init({
                            drawerContent: quickshopHtml,
                            drawerModalId: 'QuickShopDrawerModal',
                            drawerType: 'right',
                            triggerEvent: 'click',
                            triggerElem: '.quick-shop-hidden-trigger',
                            removeOnDestroy: true,
                            initCallback: function(){
                                self.$currentModal = this;
                                self.$currentModal.openDrawer();
                            },
                            openCallback: function(){                                
                                // Clean up previous quickshop instance if it exists
                                if (self.$currentQuickshop && self.$currentQuickshop.destroy) {
                                    self.$currentQuickshop.destroy();
                                }
                                
                                console.log('creating new quickshop ViewProduct instance');
                                self.$currentQuickshop = new ViewProduct({el: $('.product-quickshop .product-detail-container')});
                                console.log("srijan",self.$currentQuickshop)
                                const productDetailContainer = $('.product-quickshop .product-detail-container');

                                // Use morphdom on any anchor element that would navigate to a different product page
                                productDetailContainer.find('a[href*="/products/"]:not(.view-full)').on('click', function(e) {
                                    
                                    const href = e.currentTarget.getAttribute('href');
                                    if (href && !href.includes('#') && href.includes('/products/')) {
                                        e.preventDefault();
                                
                                        const quickshopUrl = ORW.utilities.updateUrlParam(href, 'view', 'quickshop');
                                
                                        fetch(quickshopUrl)
                                        .then(response => response.text())
                                        .then(html => {
                                            const parser = new DOMParser();
                                            const doc = parser.parseFromString(html, 'text/html');
                                            const newDetailContainer = doc.querySelector('.product-detail-container');
                                                                                            
                                            // Use morphdom to update the current detail container
                                            morphdom(productDetailContainer[0], newDetailContainer.outerHTML, {
                                                onBeforeElUpdated: function(fromEl, toEl) {
                                                        if (fromEl.isEqualNode(toEl)) {
                                                            return false;
                                                        }
                                                        return true;
                                                    }
                                            });
                                        })
                                        .catch(error => console.error('Error loading product page:', error));
                                    }
                                });
                                
                                if (ORW.marketing && ORW.marketing.initQuickshopWatchers) {
                                    ORW.marketing.initQuickshopWatchers();
                                } 
                            },
                            closeCallback: function(){
                                console.log('quickshop close');
                                
                                // Clean up quickshop instance
                                if (self.$currentQuickshop && self.$currentQuickshop.destroy) {
                                    self.$currentQuickshop.destroy();
                                    self.$currentQuickshop = null;
                                }
                                
                                if (self.$currentModal) {
                                    self.$currentModal.destroy();
                                    self.$currentModal = false;
                                }
                            },
                            events: {
                                'ajax-reload-inner' : function(e,url){
                                    quickshopCtl(e,url);
                                }
                            }
                        });
                    }
                }
            });
        }
        var events = {
            'click .quick-shop-trigger' : quickshopCtl,
            'click .quick-shop-trigger-link' : quickshopCtl
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    destroy: function() {
        var self = this;
        if (self.unsubscribeCartUpdate) self.unsubscribeCartUpdate();
        self.undelegateEvents();
    }

});

// Define the module here 
let OneQuickShop = {
    init: function (settings) {
        if (!settings.el) {
            settings.el = $('body');
        }
        return new OneQuickShopView(settings);
    }
}

// Output the module
export default OneQuickShop;